(function(){
    'use strict';

    angular.module('footerModule', ['journey.veil', 'journey.canvas.srv', 'infinite-scroll'])
        .controller('footerCtrl', ['$scope', '$location', '$rootScope', 'veilService', '$stateParams', 'canvasService', '$timeout', 'cacheService','scrollLoader', 'helpers', '$sce', '$q', footerController]);

    function footerController($scope, $location, $rootScope, veilService, $stateParams, canvasService, $timeout, cacheService, scrollLoader, helpers, $sce, $q){
        //Save as Template modal
        $scope.saveAsTemp = false;
        $scope.featureFlagsLoaded = false;

        $scope.isMasterAccount = helpers.readCookie('isMasterAccount') === '1'

        $scope.defaultTemplateList = $rootScope.journeyDefaultTemplates;

        $scope.$watch('journeyDefaultTemplates', function(val) {
            if(val) {
                $scope.defaultTemplateList = $rootScope.journeyDefaultTemplates;
                $scope.defaultTemplateList.unshift({
                    key: 'startFromScratch',
                    id: 'scratch',
                    JourneyName: 'custom.templates.fromScratch',
                    JourneyDescription: 'custom.templates.fromScratch.desc'
                });
            }
        });

        //Checks if path contains canvas word in the url
        var isCanvasPath = function() {
            return $location.path().indexOf('canvas') > -1;
        };

        var init = function() {
            $scope.footerModule = isCanvasPath();
        };
        init();

        $scope.$watch('footerModule', function(val) {
            $scope.templatesModal = false;
            $scope.extraVeilHeader = false;
            $scope.saveAsTemp = false;
        });

        //Save Journey global button
        $scope.saveJourney = function(noLoader) {
            // we should only save draft ones
            if($rootScope.currentStatus !== 1) {
                //log status save
                Intercom('trackEvent', 'AP-ERRORS', {
                    description : 'Trigger this event when an incorrect status is triggered',
                    metadata: {
                        errorType: 'status',
                        api: 'update journeys',
                        status: $rootScope.currentStatus
                    }
                });

                return;
            }
            var jbTitle = $rootScope.currentJBTitle || 'Journey Name';
            if(!noLoader) {
                //$rootScope.$emit('jbLoader', true, true);
                $rootScope.$emit('errorMsg', $scope.translate('common.saved.successful'), 'confirmation', 2500);
            }

            if ($stateParams.canvasId) {
                if($rootScope.unsavedData.length && !noLoader) {
                    $rootScope.unsavedData.forEach(function (id) {
                        $rootScope.$emit('saveUnsavedData' + id);
                    });
                }
                // existing canvas only update the canvas
                const connData = helpers.updateAllPos($rootScope.connections);
                var payload = {
                    JourneyTitle: jbTitle,
                    JourneyConfiguration: JSON.stringify(connData)
                };

                if (!$rootScope.connections) {
                    return;
                }
                canvasService
                    .updateJourney(payload, $stateParams.canvasId, $rootScope.connections.length)
                    .success(function (res) {
                        $timeout(function () {
                            $rootScope.$emit('jbLoader', false, true);
                        }, 0);
                    })
                    .error(function (err) {
                        //Error msg from backend when failing
                        $rootScope.$emit('errorMsg', err.Message);
                        $timeout(function () {
                            $rootScope.$emit('jbLoader', false, true);
                        }, 0);
                    });

            }
        };
        //End Save Journey global button

        $scope.duplicateAutomation = () => {
            $scope.apToCopy = {id:$stateParams.canvasId, title: $rootScope.currentJBTitle}
            $scope.copyApModal = true;
        };

        $scope.cancelCopy = function () {
            $scope.copyApModal = false;
            $scope.copyError = false;
        };

        $scope.copyName = {input: ''};
        $scope.savefromCanvas = true;
        $scope.saveCopy = function () {
            if(!$scope.copyName.input) {
                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.601'));
                $scope.copyError = true;
                return;
            }
            var jbName = $scope.copyName.input;
            $scope.displayCopyMenu = [];
            $scope.toolsOpts = [];

            var _next = function (res) {
                if (res.data) {
                    var jbConfig = JSON.parse(res.data.JourneyConfiguration) || [],
                        jbEmails = [],
                        jbEmailIds = [],
                        emailPromises;

                    jbEmails = jbConfig.filter(i => (i.elemName === 'SendMail' && !i.isDummy && i.data.emailId !== '11111111'));
                    jbEmailIds = jbEmails.map(i => i.data.emailId);
                    emailPromises = jbEmails.map(function(i) {
                        return canvasService.duplicateEmailValidName(i.data.emailId, i.emailData.EmailName, res.data.Status, res.data.JourneyId);
                    });

                    if(jbEmails.length) {
                        $q.all(emailPromises).then(function (res) {

                            jbConfig = jbConfig.map(function (item) {
                                if (item.elemName === 'SendMail') {
                                    var sendEmailIndex = jbEmailIds.indexOf(item.data.emailId);
                                    if (sendEmailIndex > -1) {
                                        item.data.emailId = res[sendEmailIndex].data.Id;
                                        item.data.emailName = res[sendEmailIndex].data.EmailName;
                                        item.emailData = res[sendEmailIndex].data;
                                        item.emailData.TemplateContent = '';
                                        item.emailData.TemplateText = '';
                                        canvasService.generateThumbs(item.data.emailId).then(() => {});
                                    }
                                }

                                return item;
                            });

                            canvasService
                                .createJourney(jbName, JSON.stringify(jbConfig))
                                .success(function (res) {
                                    $scope.copyName = {input: ''};
                                    $scope.cancelCopy();
                                    $scope.isLoading = false;
                                    window.location = window.location.origin + '/#/canvas/' + res.JourneyId;
                                    window.location.reload(true);
                                });
                        }).catch(function() {
                            $rootScope.$emit('jbLoader', false);
                            $scope.isLoading = false;
                        });
                    } else {
                        canvasService
                            .createJourney(jbName, JSON.stringify(jbConfig))
                            .success(function (res) {
                                $scope.copyName = {input: ''};
                                $scope.cancelCopy();
                                $scope.isLoading = false;
                                window.location = window.location.origin + '/#/canvas/' + res.JourneyId;
                                window.location.reload(true);
                            }).catch(function() {
                            $scope.isLoading = false;
                        });
                    }
                } else {
                    $rootScope.$emit('errorMsg', $scope.translate('canvas.error.607'));
                    $scope.isLoading = false;
                }
            };

            if(!$scope.isLoading) {
                $scope.isLoading = true;
                //Get the journey
                canvasService
                    .getJourney($scope.apToCopy.id)
                    .then(_next);
            }

        };

        //Save Journey as a Template Function
        var _saveJourneyTemplate = function() {
            var jbTitle = $rootScope.currentJBTitle || 'Journey Name',
                jbTemplateName = $scope.templateName,
                jbTemplateDescription = $scope.templateDescription;

            $rootScope.$emit('jbLoader', true);
            //new canvas, create and redirect
            canvasService
                .createJourneyTemplate(jbTitle, jbTemplateName, jbTemplateDescription, JSON.stringify($rootScope.connections))
                .success(function (res) {
                    if($scope.paginateTemplateList && $scope.paginateTemplateList.resList) {
                        if(!$scope.findInList(res.TemplateId)[0]) {
                            $scope.paginateTemplateList.resList[0].unshift(res);
                        }
                    } else {
                        $scope.newTemplate = res;
                    }


                    $rootScope.$emit('errorMsg', $scope.translate('canvas.templates.confirmSavedTpl'), 'confirmation');
                    $rootScope.$emit('jbLoader', false);
                    $scope.templateName = '';
                    $scope.templateDescription = '';
                });

        };
        //End Save Journey as a Template Function

        $scope.loadTemplateConfirmation = false;
        //Select Template Journey
        $scope.selectTemplate = function(template) {

            if(template.IsGeneralTemplate) {
                //load template data for "canvas.general.template.1.title"
                $scope.displayInfoTemplateModal = true;
                $scope.setUpTemplate(template);
            } else {
                $scope.loadTemplateConfirmation = true;
            }

            $scope.cancelTplSelect = function (closeBoth) {
                if(closeBoth) {
                    $scope.hideModal();
                }
                $scope.loadTemplateConfirmation = false;
                $scope.displayInfoTemplateModal = false;
                $scope.videoData = '';
            }

            $scope.selectTplConfirm = function () {
                var tplTitle = template.JourneyTitle || 'Journey Name',
                tplConfig = template.JourneyConfiguration;
                $scope.loadTemplateConfirmation = false;
                $rootScope.$emit('jbLoader', true);

                if(template.IsGeneralTemplate) {
                    tplConfig = JSON.stringify(template.JourneyConfiguration);
                    tplTitle = $rootScope.currentJBTitle;
                }

                if ($stateParams.canvasId) {
                    // existing canvas only update the canvas
                    var payload = {
                        JourneyTitle: tplTitle,
                        JourneyConfiguration: tplConfig
                    };
                    canvasService
                        .updateJourney(payload, $stateParams.canvasId, template.JourneyConfiguration.length)
                        .success(function (res) {
                            cacheService.destroyCache('jb:' + res.JourneyId + ':config');
                            cacheService.destroyCache('jb:' + res.JourneyId + ':title');
                            cacheService.deleteCachePattern('journeys:all:');

                            if(template.IsGeneralTemplate && $rootScope.localStorageSupported) {
                                localStorage.setItem('jbFromDefaultTemplate-' + res.JourneyId, 'true');
                                localStorage.setItem('jbFromDefaultTemplateName-' + res.JourneyId, template.key);

                                switch (template.key) {
                                    case 'welcomeNewSubscribers':
                                        AP.Analytics({eventLabel: 'welcometactivated'});
                                        Intercom('trackEvent', 'ap-t-welcome');
                                        break;
                                    case 'promoteTargetOpens':
                                        Intercom('trackEvent', 'AP-T-PromoteTargetOpens');
                                        break;
                                    case 'promoteTargetClicks':
                                        Intercom('trackEvent', 'AP-T-PromoteTargetClicks');
                                        break;
                                    case 'promoteTargetOpensClicksWebsiteEngagement':
                                        Intercom('trackEvent', 'AP-T-PromoteTargetWE');
                                        break;
                                    case 'followUpSeries':
                                        Intercom('trackEvent', 'AP-T-Followup');
                                        break;
                                    case 'abandonedCart':
                                        Intercom('trackEvent', 'AP-T-Cart');
                                        break;
                                    case 'feedbackRequest':
                                        Intercom('trackEvent', 'AP-T-Feedback');
                                        break;
                                    case 'reviewRequest':
                                        Intercom('trackEvent', 'AP-T-Review');
                                        break;
                                }
                            } else {
                                //Track Event Intecrom - Created from Template
                                Intercom('trackEvent', 'AP - created journey from template');
                            }

                            window.location = '/#/canvas/' + res.JourneyId;
                            window.location.reload(true);
                        })
                        .error(function (err) {
                            //Error msg from backend when failing
                            $rootScope.$emit('errorMsg', err.Message);
                            $timeout(function () {
                                $rootScope.$emit('jbLoader', false);
                            }, 0);
                        });
                } else {
                    //new canvas, create and redirect
                    canvasService
                        .createJourney(tplTitle, tplConfig)
                        .success(function (res) {
                            if(template.IsGeneralTemplate && $rootScope.localStorageSupported) {
                                localStorage.setItem('jbFromDefaultTemplate-' + res.JourneyId, 'true');
                            }

                            window.location = '/#/canvas/' + res.JourneyId;
                            window.location.reload(true);
                            return;
                        });
                }

            }

        };

        $rootScope.$on('displayInfoSubModal', (evt, data) => {
            $scope.welcomeNewSubscribers = false;
            $scope.promoteTargetOpens = false;
            $scope.promoteTargetClicks = false;
            $scope.promoteTargetOpensClicksWebsiteEngagement = false;
            $scope.followUpSeries = false;
            $scope.abandonedCart = false;
            $scope.feedbackRequest = false;
            $scope.reviewRequest = false;
            $scope.facebookAudience = false;
            $scope.displayInfoSingleModal = true;
            $scope.journeyTplTitle = $scope.translate(`canvas.coach.${data}.subcategory`);
            $scope.videoData = $sce.trustAsHtml($scope.getVideoData(data));
            $scope[data] = true;

            setTimeout(function() {
                $( ".template-info .content" ).scrollTop(0);
            }, 100)
        });

        $scope.setUpTemplate = (template) => {
            $( ".template-info .content" ).scrollTop(0);

            $scope.welcomeNewSubscribers = false;
            $scope.promoteTargetOpens = false;
            $scope.promoteTargetClicks = false;
            $scope.promoteTargetOpensClicksWebsiteEngagement = false;
            $scope.followUpSeries = false;
            $scope.abandonedCart = false;
            $scope.feedbackRequest = false;
            $scope.reviewRequest = false;
            $scope.facebookAudience = false;

            $scope.videoData = $sce.trustAsHtml($scope.getVideoData(template.key));
            $scope[template.key] = true;


            $scope.level = template.level;
            $scope.journeyTplTitle = $scope.translate(template.JourneyName);
            $scope.currentTplId = template.id;
        };

        $scope.getVideoData = (key) => {
            return {
                welcomeNewSubscribers: '<div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div class="wistia_embed wistia_async_amtyi1h65a seo=false videoFoam=true" style="height:100%;width:100%">&nbsp;</div></div></div>',
                promoteTargetOpens: '<div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div class="wistia_embed wistia_async_ghuhu5wxr4 seo=false videoFoam=true" style="height:100%;width:100%">&nbsp;</div></div></div>',
                promoteTargetClicks: '<div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div class="wistia_embed wistia_async_fpf9tlxifv seo=false videoFoam=true" style="height:100%;width:100%">&nbsp;</div></div></div>',
                promoteTargetOpensClicksWebsiteEngagement: '<div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div class="wistia_embed wistia_async_5g9jzvl1ql seo=false videoFoam=true" style="height:100%;width:100%">&nbsp;</div></div></div>',
                followUpSeries: '<div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div class="wistia_embed wistia_async_h4xh22op0s seo=false videoFoam=true" style="height:100%;width:100%">&nbsp;</div></div></div>',
                abandonedCart: '<div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div class="wistia_embed wistia_async_qt67p83yr0 seo=false videoFoam=true" style="height:100%;width:100%">&nbsp;</div></div></div>',
                feedbackRequest: '<div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div class="wistia_embed wistia_async_yauft446ny seo=false videoFoam=true" style="height:100%;width:100%">&nbsp;</div></div></div>',
                reviewRequest: '<div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div class="wistia_embed wistia_async_0ecb16y4xe seo=false videoFoam=true" style="height:100%;width:100%">&nbsp;</div></div></div>',
                facebookAudience: '<div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div class="wistia_embed wistia_async_0ecb16y4xe seo=false videoFoam=true" style="height:100%;width:100%">&nbsp;</div></div></div>'
            }[key || 'welcomeNewSubscribers']
        }
        $scope.getVideoData();

        //Display the Save As Template modal
        $scope.saveAsTemplate = function() {
            $scope.saveAsTemp = true;
        }

        //Cancel save as Template Action
        $scope.cancelSaveAs = function() {
            $scope.saveAsTemp = false;
        }

        //Save as template button
        $scope.saveAsTemplateBtn = function() {
            //Track saved template Intercom
            Intercom('trackEvent', 'AP - saved journey templates');

            var rootConn = $rootScope.connections || [];
            if ($scope.dataTplFormFilledCorrectly()) {
                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.601'));
            //validate that we have something to save.
            } else if(rootConn.length === 0) {
                $rootScope.$emit('errorMsg', $scope.translate('canvas.activate.error.2'));
                return;
            }
            //If data is correct, we proceed to save the data
            else {
                _saveJourneyTemplate();
                $scope.saveAsTemp = false;
            }
        }

        //Validates if data is filled correctly or not for save as template form
        $scope.templateDescription = '';
        $scope.templateName = '';
        $scope.dataTplFormFilledCorrectly = function () {
            var res = false;
            $scope.displayErrorName = false;
            $scope.displayErrorDescription = false;

            if (!$scope.templateName) {
                $scope.displayErrorName = true;
                res = true;
            }

            if (!$scope.templateDescription) {
                $scope.displayErrorDescription = true;
                res = true;
            }

            return res;
        };

        //Functions for crop text on templates, title and description
        $scope.parseText = function(text, type) {

            if (text === null || text === undefined ) {
                text = 'No text available';
            }
            var textLength = text.length;

            if (textLength > 21 && type === 'title') {
                text = text.slice(0, 21) + "...";
            } else if (textLength > 110 && type === 'description') {
                text = text.slice(0, 110) + "..."
            }

            return text;
        }
        //End function for crop text


        //Clear all selected templates
        $scope.clearSelected = function() {
            $scope.selectedTemplate.length = 0;
            $scope.savedOptions = false;
        }
        //End Clear selected

        //Toggle List Item to check if a checkbox is checked, If not we add it to the array of IDs, if not we delete it and just save the ones selected
        $scope.selectedTemplate = [];

        $scope.toggelListItem = function (listItem) {

            var index = $scope.selectedTemplate.indexOf(listItem);

            if (index > -1) {
                $scope.selectedTemplate.splice(index, 1);
            } else {
                $scope.selectedTemplate.push(listItem);
            }

            if ($scope.selectedTemplate.length) {
                $scope.defaultOptions = true;
                $scope.savedOptions = true;
            }else {
                $scope.defaultOptions = false;
                $scope.savedOptions = false;
            }

        };
        //End toggle list

        //Find ids into Template list
        $scope.findInList = function(id) {
            var index, dept;
            for(var i=0; i<$scope.paginateTemplateList.resList.length; i++) {
                for(var j=0; j<$scope.paginateTemplateList.resList[i].length; j++) {
                    if($scope.paginateTemplateList.resList[i][j].TemplateId === id) {
                        index = j;
                        dept = i;
                        break;
                    }
                }
            }
            return [dept, index];
        };

        //Function to receive list of array and prepare them to be deleted on the front end view
        $scope.deleteArray = function(ids) {
            var idsToDelete = [];
            ids.forEach(function(entry) {
                idsToDelete.push($scope.findInList(entry));
            });
            return idsToDelete;
        };

        $scope.deleteSelected = function() {
            $scope.deleteConfirmation = true;

            $scope.deleteTemplates = function() {
                $rootScope.$emit('jbLoader', true);

                var templatesArray = $scope.selectedTemplate;

                canvasService
                    .deleteTemplate(templatesArray)
                    .success(function(){

                        //Delete Templates on the front end view
                        for (let i = 0; i < templatesArray.length ; i++) {
                            $scope.paginateTemplateList.resList[0] = $scope.paginateTemplateList.resList[0].filter((list) => list.TemplateId !== templatesArray[i]);
                        }

                        //Close Confirmation Modal
                        $scope.deleteConfirmation = false;
                        // Close options for delete templates
                        $scope.savedOptions = false;
                        //Empty the array
                        $scope.selectedTemplate = [];

                        //Close Modal
                        $timeout(function(){
                            $rootScope.$emit('jbLoader', false);
                        }, 0);

                    })
                    .error(function(){

                        $timeout(function(){
                            $rootScope.$emit('jbLoader', false);
                        }, 0);
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.607'));
                    });
            };

             $scope.cancelDelete = function() {
                $scope.deleteConfirmation = !$scope.deleteConfirmation;
             }

        };


        //Handling views on the Default Benchmark Templates. Display Grid or List view
        $scope.gridDefaultTemplate = true;
        $scope.gridTemplate = true;

        $scope.defaultViews = function(tpl) {
            //Checking which tab is open. Saved Templates or Default Template
            if ($scope.savedTemplateView === true ){

                if (tpl === 'list') {
                    $scope.gridTemplate = false;
                    $scope.listTemplate = true;
                } else {
                    $scope.gridTemplate = true;
                    $scope.listTemplate = false;
                }

            } else {

                if (tpl === 'list') {
                    $scope.listDefaultTemplate = true;
                    $scope.gridDefaultTemplate = false;
                } else {
                    $scope.gridDefaultTemplate = true;
                    $scope.listDefaultTemplate = false;
                }

            }
        };
        //End Handling views on the Default Benchmark Templates. Display Grid or List view

        $scope.$watch('paginateTemplateList.resList[0]', (val) => {
            if(val && $scope.newTemplate) {
                if(!$scope.findInList($scope.newTemplate.TemplateId)) {
                    $scope.paginateTemplateList.resList[0].unshift($scope.newTemplate);
                }

                $scope.newTemplate = '';
            }
        });

        $scope.displaySearch = () => {
            $scope.searchHandler = true;
        };

        $scope.hideSearch = () => {
            $scope.searchHandler = false;
            $scope.searchTemplate = '';
            $scope.searchText = false;
        };

        $scope.$watch('searchTemplate', (val) =>{
            if(val) {
                $scope.searchText = true;
            } else {
                $scope.searchText = false;
            }
        });

        $scope.displayTemplatesMenu = () => {
            $scope.saveAsTemp = false;
            $scope.showTemplatesMenu = true;
            $scope.preventClosing = true;
        };

        $scope.displayTemplatesModalMenu  = () => {
            $scope.templateModalOptions = true;
            $scope.preventClosing = true;
        };

        $scope.$on('closeTemplateMenu', () => {
            if($scope.newAutomation) {
                $scope.validClickingArea();
            } else {
                if(!$scope.preventClosing) {
                    $scope.showTemplatesMenu = false;
                    $scope.templateModalOptions = false;
                }
                else {
                    $scope.preventClosing = false;
                }
            }
        });

        $scope.newAutomation = false;
        $rootScope.$on('use-template-view', () => { $scope.useTemplate(); $scope.newAutomation = true; });

        //Use Template
        $scope.useTemplate = function () {
            if(!$scope.paginateTemplateList) {
                $scope.paginateTemplateList = new scrollLoader(true);
                $scope.paginateTemplateList.nextPage();
                $scope.setTemplateScrollLogic();
            }

            var canvasEl = document.querySelector(".canvas");
            $scope.modalLeft = (canvasEl.offsetLeft * -1) + 200;
            $scope.modalTop = canvasEl.offsetTop * -1.0090;
            $scope.displayInfoTemplateModal = false;
            $scope.videoData = '';
            $scope.templatesModal = true;
            $rootScope.$emit('displayExtraVeil', true, false);
            $scope.extraVeilHeader = true;
            $scope.saveAsTemp = false;
        };

        $scope.setTemplateScrollLogic = function() {
            angular.element(
                document.querySelector('.templatesContainer')).bind("scroll",
                function () {
                    if(!$scope.paginateTemplateList.busy && !$scope.paginateTemplateList.stopLoading) {
                        $scope.paginateTemplateList.nextPage();
                    }
                }
            );
        };

        $scope.hideModal = function() {
            $scope.templatesModal = false;
            $scope.displayInfoTemplateModal = false;
            $scope.videoData = '';
            $scope.extraVeilHeader = false;
            $rootScope.$emit('displayExtraVeil', false, false);
        };

        $scope.buildFromScratch = () => {
            $scope.newAutomation = false;
            AP.Analytics({eventLabel: 'startfromscratch'});
            Intercom('trackEvent', 'ap-startedfromscratch');
            if($rootScope.connections && $rootScope.connections.length) {
                $rootScope.connections = [];
                $scope.saveJourney(true);
                $timeout(() => {
                    window.location = '/#/canvas/' + $stateParams.canvasId;
                    window.location.reload(true);
                    return;
                }, 300);
            } else {
                $scope.hideModal();
                $rootScope.$emit('displayEntryModal');
            }
        };

        //Use template functions
        $scope.templateView = true;
        $scope.activeTabTemplate = true;
        $scope.savedTemplateView = false;
        $scope.activeTabSavedTemplates = false

        //Show templates tab
        $scope.showTemplates = function() {
            $scope.activeTabSavedTemplates = false;
            $scope.savedTemplateView = false;
            $scope.savedOptions = false;
            $rootScope.$emit('displayExtraVeil', true, false);
            $scope.templateView = true;
            $scope.activeTabTemplate = true;
            $scope.clientEmail = $scope.clientEmail || $rootScope.cSettings.SignEmail;
        };

         //Show saved templates tab
        $scope.showSavedTemplates = function() {
            $scope.templateView = false;
            $scope.activeTabTemplate = false;
            $scope.activeTabSavedTemplates = true;
            $scope.savedTemplateView = true;
            $scope.clientEmail = $scope.clientEmail || $rootScope.cSettings.SignEmail;
        };

        $scope.displayDeactivateModal = () => {
            $scope.deactivateModal = true;
        };

        $scope.closeDeactivateJourney = () => {
            $scope.deactivateModal = false;
        };

        $scope.deactivateJourney = function () {
            const journeyId = $stateParams.canvasId;

            if (!$stateParams.canvasId || !$rootScope.jbToken) {
                $rootScope.$emit('errorMsg', $scope.translate('canvas.deactivate.error'), 'error');
                return;
            }

            canvasService
                .setJourneyStatus(journeyId, 4)
                .success(function () {
                    $scope.deactivateModal = false;
                    location.reload(true);
                })
                .error(function () {
                    $rootScope.$emit('errorMsg', $scope.translate('canvas.deactivate.error'), 'error');
                });
        };

        $rootScope.$on('connectionUpdated', (evt, conns) => {
            if(conns && conns.length > 1) {
                $scope.disableActivate = false;
            } else {
                $scope.disableActivate = true;
            }
        });

        $scope._validflow = function(validRes) {
            let errSent = false,
                journeyId = $stateParams.canvasId;

            if(validRes.isValid) {
                //Track Intercom Activated journeys
                Intercom('trackEvent', 'AP - Activated Journey');
                if($rootScope.connections[0].fromTemplate) {
                    Intercom('trackEvent', `AP-ActivateT-${$rootScope.connections[0].fromTemplate}`);
                } else {
                    Intercom('trackEvent', 'ap-activate-startedfromscratch');
                }

                const connData = helpers.updateAllPos($rootScope.connections);
                const payload = {
                    JourneyTitle: $rootScope.currentJBTitle,
                    JourneyConfiguration: JSON.stringify(connData)
                };

                canvasService
                    .updateJourney(payload, $stateParams.canvasId, $rootScope.connections.length)
                    .success(function (res) {
                        canvasService.activateJourney(journeyId)
                            .success(function(res) {
                                $scope.disableButton = false;
                                if(res.JourneyConverted) {
                                    $rootScope.$emit('journeyActivated');
                                } else {
                                    $rootScope.$emit('errorMsg', $scope.translate('canvas.activate.error.1'), 'error' );
                                    Intercom('trackEvent', 'AP-E-BE');
                                }
                            })
                            .error(function(err) {
                                if(err && err.Message) {
                                    err.Message = err.Message.replace(/^\s+|\s+$/g, '');
                                }

                                if(err.Message === '1002' || err.Message === '1007') {
                                    $rootScope.$emit('errorMsg', $scope.translate('canvas.activate.error.2'), 'error' );
                                }
                                else if(err.Message === '1006') {
                                    Intercom('trackEvent', 'AP-E-BE');
                                    $rootScope.$emit('errorMsg', $scope.translate('canvas.activate.error.9'), 'error' );
                                }
                                else if(err.Message === '1008') {
                                    Intercom('trackEvent', 'AP-E-MultipleErrors');
                                    $rootScope.$emit('errorMsg', $scope.translate('canvas.activate.error.8'), 'error' );
                                }
                                else if(err.Message === '1009') {
                                    Intercom('trackEvent', 'AP-E-BE');
                                    $rootScope.$emit('errorMsg', $scope.translate('canvas.activate.error.7'), 'error' );
                                }
                                else if(err.Message === '1010') {
                                    Intercom('trackEvent', 'AP-E-MultiDisconnects');
                                    $rootScope.$emit('errorMsg', $scope.translate('canvas.activate.error.3'), 'error' );
                                }
                                else if(err.Message === '1011') {
                                    Intercom('trackEvent', 'AP-E-MultipleErrors');
                                    $rootScope.$emit('errorMsg', $scope.translate('canvas.activate.error.5'), 'error' );
                                }
                                else if(err.ErrorType === 'Activate' && err.Message === '1020') {
                                    Intercom('trackEvent', 'AP-E-BE');
                                    $rootScope.$emit('errorMsg', $scope.translate('canvas.email.engagement.email.error'), 'error' );
                                    $rootScope.$emit('errEngagement_' + err.ElementId, true);
                                }
                                else if(err.ErrorType === 'Activate' && AP.Flags.expire && (err.Message.indexOf('1013') > -1)) {
                                    $rootScope.$emit('expire');
                                }
                                else if (err.ErrorType === 'Activate' && AP.Flags.upgrade
                                    && ((err.Message.indexOf('1004') > -1) || (err.Message.indexOf('1005') > -1))) {
                                    $rootScope.$emit('upgrade');
                                }
                                else if(err.Message > '1000' && err.Message < '1012') {
                                    Intercom('trackEvent', 'AP-E-BE');
                                    $rootScope.$emit('errorMsg', $scope.translate('canvas.activate.error.1'), 'error' );
                                }
                                else {
                                    Intercom('trackEvent', 'AP-E-BE');
                                    $rootScope.$emit('errorMsg', $scope.translate('canvas.activate.error.1'), 'error' );
                                }

                                $scope.disableButton = false;
                            });
                    })
                    .error(function (err) {
                        $scope.disableButton = false;
                    });
            } else {
                $scope.disableButton = false;
                if(validRes.disconnectedElements.length > 0 && validRes.unsavedData.length > 0) {
                    for(var i = 0; i<validRes.disconnectedElements.length; i++) {
                        $scope.$emit('activateErr_' + validRes.disconnectedElements[i], true);
                    }

                    for(var i = 0; i<validRes.unsavedData.length; i++) {
                        $scope.$emit('emptyErr_' + validRes.unsavedData[i], true);
                    }

                    Intercom('trackEvent', `AP-E-MultipleErrors`);
                    $rootScope.$emit('errorMsg', $scope.translate('canvas.activate.error.5'), 'error');
                }else {
                    if(validRes.disconnectedElements.length > 0) {
                        for(var i = 0; i<validRes.disconnectedElements.length; i++) {
                            $scope.$emit('activateErr_' + validRes.disconnectedElements[i], true);
                        }
                        Intercom('trackEvent', 'AP-E-MultiDisconnects');
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.activate.error.3'), 'error');
                        errSent = true
                    }

                    if(validRes.unsavedData.length > 0) {
                        for(var i = 0; i<validRes.unsavedData.length; i++) {
                            $scope.$emit('emptyErr_' + validRes.unsavedData[i], true);
                        }
                        if(!errSent) {
                            $rootScope.$emit('errorMsg', $scope.translate('canvas.activate.error.4'), 'error');
                            Intercom('trackEvent', `AP-E-MultiMissingDetails`);
                        }
                    }

                    if(validRes.dummyNodes.length > 0) {
                        for(var i = 0; i<validRes.dummyNodes.length; i++) {
                            $scope.$emit('emptyErr_' + validRes.dummyNodes[i], true);
                        }
                        if(!errSent) {
                            $rootScope.$emit('errorMsg', $scope.translate('canvas.activate.error.8'), 'error');
                            Intercom('trackEvent', `AP-E-MultipleErrors`);
                        }
                    }
                }
            }
        }

        $scope.disableActivate = true;
        $scope.activateJourney = function() {
            if (!$rootScope.hasAproPublish) {
                $rootScope.$emit('upgrade');
                return false;
            }

            //Get the param of the journey
            var validRes,
                rootConn = $rootScope.connections || [];

            $scope.disableButton = true;

            // set all to false, before validating
            for (var i = 0; i < rootConn.length; i++) {
                $scope.$emit('activateErr_' + rootConn[i].id, false);
            }

            // test for a valid jb
            validRes = helpers.isValidJourney();
            if(validRes.hasFacebookAudience && validRes.hasFacebookAudience.length) {
                canvasService.getConnections()
                    .then(({data}) => {
                        if(data.ValidConnection) {
                            for(var i = 0; i<validRes.hasFacebookAudience.length; i++) {
                                $scope.$emit('activateFbErr_' + validRes.hasFacebookAudience[i], false);
                            }
                            $scope._validflow(validRes);
                        } else {
                            for(var i = 0; i<validRes.hasFacebookAudience.length; i++) {
                                $scope.$emit('activateFbErr_' + validRes.hasFacebookAudience[i], true);
                            }
                            $scope.disableButton = false;
                        }
                    })
                    .catch(() => {
                        $scope._validflow(validRes);
                    });
            } else {
                $scope._validflow(validRes);
            }
        };

        // Check if active
        $scope.isActive = false;
        $rootScope.$on('activeJourney',  function(evt, status){
            $scope.isActive = status;
            $scope.isDeactive = false;
            $scope.isBlocked = false;
        });

        // Check if active
        $scope.isBlocked = false;
        $rootScope.$on('blockedJourney',  function(evt, status, blockDate){
            $scope.isBlocked = true;
            $scope.isActive = true;
            $scope.isDeactive = false;
            $timeout(() => {
                $rootScope.$emit('entryBlock', true, blockDate);
            }, 1000);
        });

        $scope.isDeactive = false;
        $rootScope.$on('deactivateJourney',  function(evt, status){
            $scope.isDeactive = status;
            $scope.isActive = true;

            // Added new isJourneyDeactive for know in the journey is deactive in the
            // other modal
            $rootScope.isJourneyDeactive = status;
            //Intercom track event De-activated Journey
            Intercom('trackEvent', 'AP - De-activated Journey');
        });

        //Checking url to display the footer module on the canvas section
        $rootScope.$on('pageLocationChanged', function(evt, next) {
            $scope.footerModule = (next.name.indexOf('canvas') > -1 && isCanvasPath());
        });

        // creates an email, when the event is triggered
        $rootScope.$on('createEmail', function(evt, noLoader) {
            $scope.saveJourney(noLoader);
        });

        $scope.hideMCont = 0;
        $scope.stopHide = function() {
            $scope.hideMCont = 0;
        };

        $scope.$on('hideFooterSaveTemplate', function() {
            if($scope.saveAsTemp) {
                if ($scope.hideMCont === 0) {
                    $scope.hideMCont = 1;
                }else {
                    $scope.saveAsTemp = false;
                    $scope.hideMCont = 0;
                }
            }else {
                $scope.hideMCont = 0;
            }
        });

        $scope.hideTemplateModal = function() {
            $scope.hideModal();
        };

        $scope.contMenu = 0;
        $scope.validClickingArea = function() {
            $scope.contMenu = 0;
            if(!$scope.searchTemplate && $scope.searchHandler) {
                $scope.hideSearch();
            }
        };

        $scope.showSummary = () => {
            $rootScope.$emit('summary', true, $stateParams.canvasId, $rootScope.currentJBTitle);
        };

        $scope.$on('hideUseTemplateModal', function() {
            if($scope.templatesModal) {
                if ($scope.contMenu === 0) {
                    $scope.contMenu = 1;
                }else {
                    $scope.hideModal();
                    //Close Confirmation modals
                    $scope.loadTemplateConfirmation = false;
                    $scope.deleteConfirmation = false;
                    $scope.contMenu = 0;
                }
            }else {
                $scope.contMenu = 0;
            }
        });

        $rootScope.$on('useTemplate', function(evt, use) {
            if(use) {
                $scope.useTemplate();
            }
        });

        $scope.replaceSearch = () => {
            $scope.searchFilter = $scope.searchTemplate.replace(/\s/g, '');
        };

        $rootScope.$on('featureFlagsLoaded', (_, key) => {
            $scope.featureFlagsLoaded = key;

            if (!$rootScope.hasAproPublish) {
                $scope.showUpsellButton = true
            }
        });
    }
})();


// WEBPACK FOOTER //
// ./app/controllers/footerController.js